import * as types from "./types";

export const getProductCategoryList = (data) => {
  return {
    type: types.GET_PRODUCT_CATEGORY_LISTING,
    payload: data,
  };
};

export const getProductCategoryById = (data) => {
  return {
    type: types.GET_PRODUCT_CATEGORY_BY_ID,
    payload: data,
  };
};

export const setQueryInStore = (query) => {
  return {
    type: types.SET_QUERY,
    payload: query,
  };
};
